module.exports = __webpack_public_path__ + "img/join_4_5.c9308ff5.jpg";